import { FilterOperator, useDataSourceListQuery } from '@kinetic-ui/data-layer';
import { useCallback, useMemo } from 'react';
import { LocationType } from '../types';
import { getNodes } from 'kineticUtils';

const useGeometricConfigEnabledLocationTypes = () => {
  const { data } = useDataSourceListQuery({
    variables: {
      sourceId: 'locationType',
      filters: {
        field: 'attributes.GEOMETRIC_CONFIGURATION_ENABLED',
        operator: FilterOperator.Equals,
        value: true,
      },
    },
  });

  const geometricConfigEnabledLocationTypes = useMemo(
    () => getNodes(data?.dataSources)?.map((source) => source.value) || [],
    [data]
  );

  return geometricConfigEnabledLocationTypes;
};

export const useIsGeometricConfigEnabled = (locationType?: LocationType) => {
  const geometricConfigEnabledLocationTypes = useGeometricConfigEnabledLocationTypes();

  const getGeometricConfigEnabled = useCallback(
    (type?: LocationType) => {
      if (!type) {
        return false;
      }
      return geometricConfigEnabledLocationTypes.includes(type);
    },
    [geometricConfigEnabledLocationTypes]
  );

  const geometricConfigEnabled = useMemo(
    () => getGeometricConfigEnabled(locationType),
    [locationType, getGeometricConfigEnabled]
  );

  return { geometricConfigEnabled, getGeometricConfigEnabled };
};
